import { GET_USER } from './gql/getUser';
import { GET_USER_PERMISSIONS } from './gql/getUserPermissions';
export const getUserProfileById = (gqlInstance, id, appIds) => {
    return gqlInstance
        .getClient('graphqlClient')
        .query({
        query: GET_USER,
        fetchPolicy: 'network-only',
        variables: {
            id,
            appIds,
        },
    })
        .then((response) => {
        return response.data.user;
    });
};
export const getUserPermissionsQuery = (gqlInstance, id, appIds) => {
    return gqlInstance
        .getClient('graphqlClient')
        .query({
        query: GET_USER_PERMISSIONS,
        fetchPolicy: 'network-only',
        variables: {
            id,
            appIds,
        },
    })
        .then((response) => {
        return response.data.user ? response.data.user.permissions : null;
    });
};
//# sourceMappingURL=user.queries.js.map